import React, { Component } from "react";
import flagUs from "../assets/flags/flag-us.svg";
import flagTr from "../assets/flags/flag-tr.svg";

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = { isMenuOpen: false };
  }

  toggleMenu = () => {
    this.setState((prevState) => ({ isMenuOpen: !prevState.isMenuOpen }));
  };

  closeMenu = () => {
    this.setState({ isMenuOpen: false });
  };

  render() {
    const { language, onLanguageChange, items = [] } = this.props;
    const { isMenuOpen } = this.state;

    return (
      <header className="nav">
        <div className="nav-inner">
          <a className="brand" href="/">
            <img
              src="/assets/branding/logo.svg"
              className="brand-mark"
              alt="wodaslabs"
            />
            <span className="brand-name">wodaslabs</span>
          </a>
          <div className="nav-right">
            <nav className={`nav-links ${isMenuOpen ? "is-open" : ""}`}>
              {items.map((item) => (
                <a
                  key={`${item.href}-${item.label}`}
                  href={item.href}
                  onClick={this.closeMenu}
                >
                  {item.label}
                </a>
              ))}
            </nav>
            <div className="nav-actions">
              <div className="nav-language" role="group" aria-label="Language">
                <button
                  type="button"
                  className={`lang-button ${
                    language === "en" ? "is-active" : ""
                  }`}
                  onClick={() => onLanguageChange("en")}
                  aria-pressed={language === "en"}
                >
                  <img src={flagUs} alt="English" />
                </button>
                <button
                  type="button"
                  className={`lang-button ${
                    language === "tr" ? "is-active" : ""
                  }`}
                  onClick={() => onLanguageChange("tr")}
                  aria-pressed={language === "tr"}
                >
                  <img src={flagTr} alt="Turkce" />
                </button>
              </div>
              <button
                className="nav-toggle"
                type="button"
                onClick={this.toggleMenu}
                aria-expanded={isMenuOpen}
                aria-label="Menu"
              >
                <span className="nav-toggle-bar" />
                <span className="nav-toggle-bar" />
                <span className="nav-toggle-bar" />
              </button>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default NavBar;
